import rolesData from '@/mockData/roles.json'
import userRolesData from '@/mockData/user_roles.json'
import RolesService from '@/services/api/roles.services'

const state = {
    roles: rolesData,
    userRoles: userRolesData,
    roleAccesses: [],
}

const mutations = {
    SET_ROLES(state, payload) {
        state.userRoles = payload
    },
    SET_ROLE_ACCESSES(state, payload) {
        state.roleAccesses = payload
    },
}

const actions = {
    getRoles({ commit }) {
        return new Promise((resolve, reject) => {
            RolesService.get('roles')
                .then((response) => {
                    commit(
                        'SET_ROLES',
                        response.data.data || response.data || [],
                    )
                    commit(
                        'SET_USER_ROLES',
                        response.data.data || response.data || [],
                    )
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
    createRole({ commit }, payload) {
        return new Promise((resolve, reject) => {
            RolesService.post('roles', {}, payload)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
    updateRole({ commit }, payload) {
        return new Promise((resolve, reject) => {
            RolesService.put('changeRole', payload.id, payload)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
    deleteRole({ commit }, payload) {
        return new Promise((resolve, reject) => {
            RolesService.delete('changeRole', payload.id)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
    getRoleAccesses({ commit }) {
        return new Promise((resolve, reject) => {
            RolesService.get('roleAccesses')
                .then((response) => {
                    commit('SET_ROLE_ACCESSES', response.data.data || response.data || [])
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
    updateRoleAccesses({ commit }, payload) {
        return new Promise((resolve, reject) => {
            RolesService.post('roleAccesses', {}, payload)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
    deleteRoleAccesses({ commit }, payload) {
        return new Promise((resolve, reject) => {
            RolesService.delete('roleAccesses', {}, { data: payload })
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
}

const getters = {
    getRoles: (state) => state.userRoles,
    getRoleAccesses: (state) => state.roleAccesses,
    getRolesInfo: (state) => (nickname, route) => {
        const userRoles = Object.keys(state.roles)
            .filter(
                (item) =>
                    state.userRoles
                        .find((item) => item.nickname === nickname)
                        ?.roles?.indexOf(item) !== -1,
            )
            .map((item) => (item = state.roles[item][route]))

        return {
            add: userRoles.some((item) => item['add'] === true),
            'show own': userRoles.some((item) => item['show own'] === true),
            'show all': userRoles.some((item) => item['show all'] === true),
            'edit own': userRoles.some((item) => item['edit own'] === true),
            'edit all': userRoles.some((item) => item['edit all'] === true),
            'delete own': userRoles.some((item) => item['delete own'] === true),
            'delete all': userRoles.some((item) => item['delete all'] === true),
        }
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
